import React from 'react'
import Helmet from 'react-helmet'
import FBThumb from 'images/digipay-healthguard.png'
import {StaticQuery, graphql} from 'gatsby'

const SITE_META = [
  {
    name: 'description',
    content: 'Mabilis, Madali, Mura'
  },
  {
    name: 'keywords',
    content: 'digipay, fintech, e-payments, bills payment, ' +
      'mobile money, e-load, e-pins, microinsurance'
  },
  {
    name: 'og:url',
    content: 'https://www.digipay.ph'
  },
  {
    name: 'og:type',
    content: 'website'
  },
  {
    name: 'og:title',
    content: 'Digipay HealthGuard'
  },
  {
    name: 'og:description',
    content: 'An affordable and accessible health insurance ' +
      'solution brought to you by Digipay, AXA, and MicroEnsure'
  },
  {
    name: 'og:image',
    content: FBThumb
  }
]

function LayoutContent(props) {
  const {title, children} = props
  return (
    <>
      <Helmet title={title} meta={SITE_META}>
        <html lang="en" />
      </Helmet>

      <main role="main">{children}</main>
    </>
  )
}

const SITE_TITLE = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

const Layout = props => (
  <StaticQuery
    query={SITE_TITLE}
    render={data =>
      <LayoutContent title={data.site.siteMetadata.title}>
        {props.children}
      </LayoutContent>
    }
  />
)

export default Layout